"use client";

import { resetIdentityClientState } from "@analytics/lib/identity-resolution";
import { clearVisitorBootstrapSnapshot } from "@analytics/lib/visitor-bootstrap-cache";
import { authClient } from "@repo/auth/client";
import { SecondaryCta } from "@repo/ui/components/design-system/cta/secondary-cta";
import { useTranslations } from "next-intl";
import { config } from "@/config";

/**
 * Sign-out for AuthWrapper / marketing surfaces (create-org, onboarding, etc.)
 * when the user is stuck outside the SaaS header account menu.
 */
export function AuthSurfaceSignOutButton({
	className,
}: {
	className?: string;
}) {
	const t = useTranslations();

	function handleSignOut() {
		resetIdentityClientState();
		clearVisitorBootstrapSnapshot();
		authClient.signOut({
			fetchOptions: {
				onSuccess: async () => {
					window.location.href = new URL(
						config.saas.redirectAfterLogout,
						window.location.origin,
					).toString();
				},
			},
		});
	}

	return (
		<SecondaryCta
			type="button"
			ctaSize="medium"
			ctaWidth="full"
			className={className}
			onClick={handleSignOut}
			data-auth-action="sign-out"
		>
			{t("app.userMenu.logout")}
		</SecondaryCta>
	);
}
